module.exports = __webpack_public_path__ + "static/media/listingImgTokio.00c122bd.svg";